import actions from "./actions";

const initialState = {
  error: null,
  total: 0,
  loading: false,
  saving: false,
  items: [],
  detail: null,
};

export default function galleryContentReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SEARCH_REQUEST:
      return { ...state, loading: true };
    case actions.SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        total: action.total,
        items: action.items,
      };
    case actions.SEARCH_ERROR:
      return { ...state, loading: false, error: action.error };

    case actions.REGISTER_REQUEST:
    case actions.UPDATE_REQUEST:
      return { ...state, saving: true };
    case actions.REGISTER_SUCCESS:
    case actions.UPDATE_SUCCESS:
      return { ...state, saving: false };
    case actions.REGISTER_ERROR:
    case actions.UPDATE_ERROR:
      return { ...state, saving: false, error: action.error };

    case actions.DETAIL_REQUEST:
      return { ...state, loading: true };
    case actions.DETAIL_SUCCESS:
      return { ...state, loading: false, detail: action.detail };
    case actions.DETAIL_ERROR:
      return { ...state, loading: false };

    case actions.DELETE_REQUEST:
      return { ...state, saving: true };
    case actions.DELETE_SUCCESS:
      return { ...state, saving: false };
    case actions.DELETE_ERROR:
      return { ...state, saving: false };

    case actions.RESET_DETAIL:
      return { ...state, detail: null };

    default:
      return state;
  }
}
